import { useState } from "react";
import "./Contact.style.css";
import { GoLocation } from "react-icons/go";
import { AiOutlineMail } from "react-icons/ai";
import { FiSmartphone } from "react-icons/fi";

import Map from "../Map/Map.component";

const Contact = () => {
  const [emptyFields, setEmptyFields] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const saveInput = (e) => {
    const { name, value } = e.target;
    if (name === "firstName") {
      setName(value);
      setEmptyFields(false);
    } else if (name === "email") {
      setEmail(value);
      setEmptyFields(false);
    } else if (name === "subject") {
      setSubject(value);
      setEmptyFields(false);
    } else if (name === "message") {
      setMessage(value);
      setEmptyFields(false);
    }
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (
      name.length < 1 ||
      email.length < 1 ||
      subject.length < 1 ||
      message.length < 1
    )
      return setEmptyFields(true);

    let details = {
      name,
      email,
      subject,
      message,
    };
    let response = await fetch(
      "https://my-portfolio-psi-self.vercel.app/sendMail",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(details),
      }
    );
    if (response.status === 200) {
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
    }
  };
  return (
    <section className="section-title section-container" id="contact">
      <h2>Contact</h2>
      <div className="contact-container">
        <div className="contact-info">
          <div className="contact-icon-text-wrapper">
            <div className="contact-icon">
              <GoLocation className="icon" />
            </div>
            <div className="contact-location-phone-email">
              <h4>Location:</h4>
              <p>23 Oktomvri Skopje, Macedonia</p>
            </div>
          </div>

          <div className="contact-icon-text-wrapper">
            <div className="contact-icon">
              <AiOutlineMail className="icon" />
            </div>
            <div className="contact-location-phone-email">
              <h4>Email:</h4>
              <p>ristoski.nikola@gmail.com</p>
            </div>
          </div>

          <div className="contact-icon-text-wrapper">
            <a href="tel:+38970798745">
              <div className="contact-icon">
                <span>
                  <FiSmartphone className="icon" />
                </span>
              </div>
            </a>
            <div className="contact-location-phone-email">
              <h4>Call:</h4>
              <p>+389 70 798 745</p>
            </div>
          </div>
          <Map />
        </div>
        <div className="contact-me-container">
          <h3>
            Drop me a line, because for succeding in business is all about
            making connections.
          </h3>

          {/* FORM */}
          <div className="contact-me-form">
            {emptyFields ? (
              <p className="empty-fields">All fields are required *</p>
            ) : null}

            <form action="">
              <div className="form-name-email">
                <input
                  type="text"
                  placeholder="Name"
                  id="name"
                  name="firstName"
                  onChange={saveInput}
                  value={name}
                />
                <input
                  type="text"
                  placeholder="Email"
                  id="email"
                  name="email"
                  onChange={saveInput}
                  value={email}
                />
              </div>
              <div className="form-subject">
                <input
                  type="text"
                  placeholder="Subject"
                  id="subject"
                  name="subject"
                  onChange={saveInput}
                  value={subject}
                />
              </div>
              <div className="form-textarea">
                <textarea
                  name="message"
                  id="message"
                  cols="30"
                  rows="10"
                  placeholder="Message"
                  onChange={saveInput}
                  value={message}
                ></textarea>
              </div>
              <div className="form-btn">
                <button
                  type="submit"
                  className="btn-send-message"
                  onClick={sendEmail}
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
